/**
 * Guidelines — ANOKOE のガイドライン
 *
 * 【この画面の性格】ここに書くのは**運営が守ると決めたこと**だけ。
 * まだ決まっていない項目を「それらしく」書き足さない（事実性①）。
 * 項目を増やすときは、決定の出どころ（SPEC / 決定番号）を伴わせる。
 *
 * 現在の掲載:
 *   - 創作の過程データについて（決定36 → docs/town/PHASE3_SPEC.md §8.0）
 *     筆致・録音は「作品」ではなく「技術そのもの」が写るため、完成物とは別に扱う。
 *     2026-08-10 に GET /api/rt/rooms/:id/strokes を参加者限定に閉じた実装と対になる約束。
 */
export const Guidelines = () => {
    return (
        <div className="max-w-3xl mx-auto px-6 pt-10 pb-20">
            <header className="mb-10">
                <p className="font-display font-bold tracking-[0.18em] text-pop text-sm mb-2">GUIDELINES</p>
                <h1 className="font-display font-black text-4xl text-ink">ガイドライン</h1>
                <p className="text-ink-2 text-sm mt-3 leading-relaxed">
                    ANOKOE が守ると決めたことを書いています。決まったことから順に増やしていきます。
                </p>
            </header>

            <section aria-labelledby="process-data" className="bg-surface border-2 border-ink rounded-pop-md p-6 shadow-pop-sm">
                <h2 id="process-data" className="font-display font-bold text-xl text-ink mb-4">
                    創作の過程データについて
                </h2>
                <div className="space-y-3 text-ink leading-relaxed">
                    <p>
                        共有キャンバスの筆致や上演の録音といった「作る過程」のデータは、参加した方以外には公開しません。
                    </p>
                    <p>
                        公開する場合も、参加した全員が同意したときだけです。
                    </p>
                    <p>
                        ANOKOE はこれらのデータを、機械学習の目的で第三者に提供しません。
                    </p>
                </div>
                <p className="text-ink-2 text-sm mt-5 pt-5 border-t-2 border-ink/10 leading-relaxed">
                    完成した作品と、それを作る過程は質が異なると考えています。
                    筆致には速度や迷い、描き順といった描き手の技術そのものが残り、
                    声にはその人の声質が残ります。だから作品の公開設定とは別に扱います。
                </p>
            </section>
        </div>
    );
};
